import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://ayannayyer.tech';
const DEFAULT_IMAGE = `${SITE_URL}/android-chrome-512x512.png`;

const Seo = ({ title, description, path = '/', type = 'website', image = DEFAULT_IMAGE }) => {
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Ayan Nayyer" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
